import { createFileRoute } from "@tanstack/react-router";
import DaciaHub from "@/pages/hub/DaciaHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/hub/dacia/")({
  head: () => routeHead("/uk/hub/dacia/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DaciaHub />
  );
}
